import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { ChannelCommunicatorService, } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { EVENT } from '../../../shared/constants/dali.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductsService } from '../../../shared/services/products/products.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';
import { callbackAdjustSolicitarTC } from 'src/app/shared/constants/adjust-callback';
import Adjust from '@adjustcom/adjust-web-sdk';
import { PopupService } from 'src/app/shared/services/popup/popup.service';
import { FirmlyApprovedService } from '../../../shared/services/firmly-approved/firmly-approved.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
var ProductSelectionComponent = /** @class */ (function () {
    /**
     * Constructor of the component.
     *
     * @param {CopyService}   copyService   Injectable copyService service.
     * @param {NavigationService} navigationService Injectable navigationService service.
     * @param {AbreCuentasService}   abreCuentasService   Injectable abreCuentasService service.
     * @param {ParametersService} parametersService   Injectable parametersService service.
     * @param {BioCatchService}   biocatchService   Injectable copyService service.
     * @param {RequestService}   requestService   Injectable requestService service.
     * @param {HeaderService}     headerService     Injectable headerService service.
     * @function headerService.show() Hides header
     */
    function ProductSelectionComponent(copyService, helper, navigationService, abreCuentasService, parametersService, productsService, headerService, taggingService, bitacoraService, channelCommunicatorService, requestService, popupService, firmlyApprovedService, configurationService) {
        this.copyService = copyService;
        this.helper = helper;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.productsService = productsService;
        this.headerService = headerService;
        this.taggingService = taggingService;
        this.bitacoraService = bitacoraService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.requestService = requestService;
        this.popupService = popupService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.configurationService = configurationService;
        this.consultation_request = 'ConsultationRequest';
        this.isJemelli = false;
        this._subscriber$ = new Subject();
        this.showHomeCredit = true;
        this.headerService.show(false, false, true);
        this.isContinuingFlow = false;
        this.hasFirmlyApprovedOffer = false;
        this.buttonLabels = {
            viewProducts: 'VerProductos',
            knowMore: 'ConoceMas',
        };
        this.productsAcepted = {};
        this.showHomeCredit = !this.abreCuentasService.getUserJemelii();
        this.isJemelli = this.abreCuentasService.getUserJemelii();
    }
    /**
     * Función de Angular ejecutada una vez el componente sea cargado, carga los productos a mostrar
     *
     * *Angular function that is run when the component is loaded, charges products to be displayed*
     */
    ProductSelectionComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var structure;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // console.warn('Copies: ', this.copyService.copies.new_client);
                        this.isNewClient = this.abreCuentasService.getIsNewClient();
                        this.popupService.popupState.subscribe(function (resp) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                if (!resp.continueFlow) {
                                    return [2 /*return*/];
                                }
                                this.isContinuingFlow = true;
                                if (this.lastButtonClicked === this.buttonLabels.viewProducts) {
                                    this.goAhead(this.productSelected);
                                }
                                else {
                                    this.goToProductDetails(this.productSelected, this.buttonLabels.knowMore);
                                }
                                return [2 /*return*/];
                            });
                        }); }, function (error) {
                            console.error('Error getting popup state:', error);
                        });
                        if (this.parametersService.getParameter('warningDisplay') &&
                            (this.channelCommunicatorService.getChannelId() === '141' ||
                                this.channelCommunicatorService.getChannelId() === '163' ||
                                this.channelCommunicatorService.getChannelId() === '131' ||
                                this.channelCommunicatorService.getChannelId() === '160')) {
                            this.navigationService.navigateToGeneralInformation('999');
                        }
                        console.log('Product-selection ----------------->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');
                        this.abreCuentasService.setMultiView(false);
                        this.productsList = this.abreCuentasService.getPostlogin() ?
                            this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE) : this.parametersService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
                        this.advance();
                        return [4 /*yield*/, this.abreCuentasService.getFlowStructure()];
                    case 1:
                        structure = _a.sent();
                        if (this.channelCommunicatorService.getChannelId() === '163') {
                            this.checkAlly();
                        }
                        else if (this.isNewClient) {
                            // this.benefitsSavingAccount = this.copyService.copies.new_client.saving_account.benefits;
                            // console.log('beneficios: ', this.benefitsSavingAccount);
                            this.listProductsAcepted(structure, true, true, true, true, false);
                        }
                        else {
                            this.listProductsAcepted(structure);
                            this.navigationService.pageLoadTag();
                            this.isPostLogin = this.abreCuentasService.getPostlogin();
                            this.channelId = this.channelCommunicatorService.getChannelId();
                            if (this.channelId === CHANNEL.SUPERAPP.CODE) {
                                setTimeout(function () {
                                    _this.adjustInit();
                                }, 1000);
                            }
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductSelectionComponent.prototype.listProductsAcepted = function (structure, multi, saving, payroll, living, consultationRequest) {
        if (multi === void 0) { multi = true; }
        if (saving === void 0) { saving = true; }
        if (payroll === void 0) { payroll = true; }
        if (living === void 0) { living = true; }
        if (consultationRequest === void 0) { consultationRequest = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.productsAcepted[BUSINESS_CONST.MULTI] = multi;
                        this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_SAVINGS] = saving;
                        this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_PAYROLL] = payroll;
                        this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_LIVING] = living;
                        this.productsAcepted[BUSINESS_CONST.PRODUCT_REQUEST_CONSULT] = consultationRequest;
                        return [4 /*yield*/, this.selectionProducts(structure)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductSelectionComponent.prototype.selectionProducts = function (structure) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // inner join products and structure
                this.productsList = this.productsList.filter(function (product) { return structure[0].flows[product.flow] !== undefined; });
                console.log('Listado de productos: ', this.productsList);
                if (this.isNewClient) {
                    this.principalProduct = this.productsList.filter(function (product) { return product.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS; })[0];
                    this.otherOptions = this.productsList.filter(function (product) { return product.product_type === BUSINESS_CONST.PRODUCT_REQUEST_CONSULT; });
                }
                this.listProductSelection();
                return [2 /*return*/];
            });
        });
    };
    ProductSelectionComponent.prototype.listProductSelection = function () {
        var _this = this;
        this.productsList = this.productsList.filter(function (product) {
            return (product.product_type === BUSINESS_CONST.MULTI && _this.productsAcepted[BUSINESS_CONST.MULTI])
                || (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS && _this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_SAVINGS])
                || (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_PAYROLL && _this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_PAYROLL])
                || (product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING && _this.productsAcepted[BUSINESS_CONST.PRODUCT_TYPE_LIVING])
                || (product.product_type === BUSINESS_CONST.PRODUCT_REQUEST_CONSULT && _this.productsAcepted[BUSINESS_CONST.PRODUCT_REQUEST_CONSULT]);
        });
        console.log('Products: ', this.productsList);
        this.evaluateProducts();
    };
    ProductSelectionComponent.prototype.checkAlly = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ally;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('ajuste para cargar flow');
                        return [4 /*yield*/, this.requestService.documentsAllies()
                                .then(function (res) { return _this.allies = res.Ally; })
                                .catch(function (err) { return console.log(err); })];
                    case 1:
                        _a.sent();
                        ally = this.allies.filter(function (item) { return item.code_Ally === _this.abreCuentasService.getAllyCode(); });
                        console.log('ally[0]  ', ally[0]);
                        this.nextToProductDetails();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductSelectionComponent.prototype.adjustInit = function () {
        this.prodAdjust = this.parametersService.getParameter('daliEnvProd');
        if (this.prodAdjust === true && this.isPostLogin === false) {
            Adjust.initSdk({
                appToken: this.parametersService.getSetting(OpEnum.ADJUST_APPTOKEN),
                environment: 'production',
                logLevel: 'none',
            });
        }
        else if (this.prodAdjust === false && this.isPostLogin === false) {
            Adjust.initSdk({
                appToken: this.parametersService.getSetting(OpEnum.ADJUST_APPTOKEN),
                environment: 'sandbox',
                logLevel: 'verbose',
            });
        }
        this.AdjustEvent();
    };
    ProductSelectionComponent.prototype.AdjustEvent = function () {
        if (this.isPostLogin === false) {
            var event_1 = {
                eventToken: 'kiix9r',
                callbackParams: callbackAdjustSolicitarTC,
            };
            this.channelId === CHANNEL.SUPERAPP.CODE ? Adjust.trackEvent(event_1) : Adjust.trackEvent(event_1);
        }
        return;
    };
    /**
     * Función para ir a los detalles del producto seleccionado
     *
     * *Go to selected product details function*
     *
     * @param {IProductsModel} product
     * @param {string} _label
     */
    ProductSelectionComponent.prototype.goToProductDetails = function (product, _label) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var category, productCamelize, CustomLabel;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.lastButtonClicked = this.buttonLabels.knowMore;
                        this.productSelected = product;
                        if (!(!this.isContinuingFlow && this.productSelected.name === 'MultiProduct')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateFirmlyApprovedOffersForPopup()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.isContinuingFlow && this.hasFirmlyApprovedOffer) {
                            this.popupService.showPopup();
                            return [2 /*return*/];
                        }
                        this.abreCuentasService.setproductSelected(product);
                        // this.configurationService.selectProductType(product);
                        this.nextToProductDetails();
                        category = {
                            module: 'body',
                            type: 'link',
                            position: 'bottom',
                        };
                        productCamelize = this.navigationService.camelize(product.name);
                        CustomLabel = _label + " | " + productCamelize;
                        this.pageTagEvent('1', category, 'click', CustomLabel);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función para empezar la solicitud del producto seleccionado
     *
     * *Function that starts solicitation of the selected product*
     *
     * @param {IProductsModel} product
     */
    ProductSelectionComponent.prototype.goAhead = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var category, CustomLabel, _a, seller_doc_num, seller_name;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log('Continuando flujo normal');
                        this.lastButtonClicked = this.buttonLabels.viewProducts;
                        console.log('Product recibido: ', product);
                        this.productSelected = product;
                        category = {
                            module: 'body',
                            type: 'image',
                            position: 'bottom',
                        };
                        CustomLabel = "Imagen | " + this.productSelected.name;
                        this.pageTagEvent('2', category, 'click', CustomLabel);
                        if (!(!this.isContinuingFlow && this.productSelected.name === 'MultiProduct')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateFirmlyApprovedOffersForPopup()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!this.isContinuingFlow && this.hasFirmlyApprovedOffer) {
                            this.popupService.showPopup();
                            return [2 /*return*/];
                        }
                        console.log('Producto seleccionado: ', this.productSelected);
                        this.abreCuentasService.setproductSelected(this.productSelected);
                        if (this.productSelected.name !== 'ConsultationRequest') {
                            if (this.channelId === CHANNEL.PORTALO.CODE) {
                                if (!this.abreCuentasService.getSellerMarca()) {
                                    _a = this.abreCuentasService.getSeller(), seller_doc_num = _a.seller_doc_num, seller_name = _a.seller_name;
                                    this.bitacoraService.saveDataInBitacora('Seller_ID_' + seller_doc_num);
                                    this.bitacoraService.saveDataInBitacora('Seller_Name_' + seller_name);
                                    this.abreCuentasService.setSellerMarca(true);
                                }
                            }
                            this.configurationService.validateBiocatch(this.productSelected);
                            /* this.bioCatchService
                              .checkCountry(false)
                              .then(response => {
                                if (response.data.response || !this.bioCatchService.getGeoServiceComplete()) {
                                  this.selectProduct(this.productSelected, 'nextToSolicitation');
                                } else {
                                  this.navigationService.navigateToGeneralInformation('dsbException');
                                }
                              }, error => {
                                console.error('BiocatchError..');
                                console.error(error);
                                this.navigationService.navigateToGeneralInformation('500');
                                if (!this.abreCuentasService.getPostlogin()) {
                                  this.navigationService.pageLoadTag(false, ['pv415', '', '', '']);
                                }
                              }).catch(() => this.navigationService.navigateToGeneralInformation('500')); */
                        }
                        else {
                            this.configurationService.selectProductType(product);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductSelectionComponent.prototype.validateFirmlyApprovedOffersForPopup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var channelsAllowed, offerData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        channelsAllowed = [
                            CHANNEL.PORTALPN.CODE,
                            CHANNEL.SUPERAPP.CODE,
                        ];
                        if (!this.abreCuentasService.getPostlogin() || !channelsAllowed.includes(this.channelId)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.firmlyApprovedService.getProductsOffer()];
                    case 1:
                        _a.sent();
                        this.firmlyApprovedOffers = this.firmlyApprovedService.getProductsFirmlyApproved();
                        if (this.firmlyApprovedOffers && this.firmlyApprovedOffers.length > 0) {
                            offerData = {
                                offerId: String(this.firmlyApprovedOffers[0].id),
                                offerType: this.firmlyApprovedOffers[0].offerType,
                            };
                            this.firmlyApprovedService.setOffer_Channel(offerData);
                            this.hasFirmlyApprovedOffer = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función que guarda la información del producto seleccionado
     *
     * *Funtion that saves selected product infomation*
     *
     * @param {IProductsModel} product
     * @param {string} advance
     */
    ProductSelectionComponent.prototype.advance = function () {
        var _this = this;
        this.configurationService.getProductIsReady().pipe(takeUntil(this._subscriber$)).subscribe(function (isReady) {
            if (isReady) {
                console.log('advance: ', _this.abreCuentasService.getproductSelected().code);
                _this.navigationService.nextStep(_this.abreCuentasService.getproductSelected().code);
            }
        });
    };
    /**
     * Función para ir a los detalles del producto seleccionado, se utiliza el código del producto
     *
     * *Function that goes to the selected product details, it uses the product code*
     */
    ProductSelectionComponent.prototype.nextToProductDetails = function () {
        if (this.channelCommunicatorService.getChannelId() === '163') {
            var product_code = this.abreCuentasService.getproductSelected().product_code;
            switch (product_code) {
                case 'TCR':
                    this.navigationService.nextStep('002');
                    break;
            }
        }
        else {
            var code = this.abreCuentasService.getproductSelected().code;
            code === '205' ? this.navigationService.nextStep('207') :
                code === '209' ? this.navigationService.nextStep('219') :
                    code === '211' ? this.navigationService.nextStep('221') :
                        code === '951' ? this.navigationService.nextStep('955') :
                            code === '999' ? this.navigationService.nextStep('998') :
                                code === '023' ? this.navigationService.nextStep('033') :
                                    code === '001' ? this.navigationService.nextStep('002') :
                                        this.navigationService.nextStep();
        }
    };
    /**
     * Función para validar el estado de los productos
     *
     * *Function that validates products states*
     */
    ProductSelectionComponent.prototype.evaluateProducts = function () {
        var _this = this;
        var rules = {};
        console.warn('evaluateProducts: Products: ', this.productsList);
        this.productsList.forEach(function (product) {
            if (!product.visibility_rule && !rules[product.visibility_rule]) {
                return;
            }
            var parameters = {
                channel_id: _this.abreCuentasService.getAppInfo().channelId,
                mobile_platform: _this.abreCuentasService.getAppInfo().platform,
                app_version: _this.abreCuentasService.getAppInfo().appVersion,
            };
            if (_this.abreCuentasService.getIsPortal()) {
                parameters = _this.parametersService.getSetting(OpEnum.BETA_PORTAL);
            }
            var rule = {
                rule_name: product.visibility_rule,
                parameters: parameters,
            };
            rules[product.visibility_rule] = rule;
        });
        var rulesRq = Object.keys(rules).map(function (key) { return rules[key]; });
        if (rulesRq.length === 0) {
            this.products = this.productsList;
            return;
        }
        console.log('product-selection >>>> Rules: ', rulesRq);
        this.productsService.validateRules(rulesRq, this.productsList)
            .then(function (productsByRules) {
            _this.products = productsByRules;
        })
            .catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
    };
    ProductSelectionComponent.prototype.pageTagEvent = function (eventNumber, category, customAction, customLabel) {
        var tagPageName = this.navigationService.getCurrentStep().tag_name;
        var event = {
            category: {
                module: EVENT.customCategory.module[category.module],
                type: EVENT.customCategory.type[category.type],
                position: EVENT.customCategory.position[category.position],
            },
            action: EVENT.customAction[customAction],
            label: customLabel ? customLabel : EVENT[tagPageName + "E" + eventNumber + "customLabel"],
        };
        this.taggingService.pageTagEvent(event);
    };
    ProductSelectionComponent.prototype.nextNewClient = function () {
        console.log('llamamos al siguiente evento');
    };
    return ProductSelectionComponent;
}());
export { ProductSelectionComponent };
